export default {
    all: {
        id: 'all',
        name: 'All',
        asset: 'All',
        icons: {
            tab: '/assets/assets_all_normal.svg',
            list: '/assets/assets_all_normal.svg',
        },
    },
    chart: {
        id: 'chart',
        name: 'Charts',
        asset: 'Chart',
        icons: {
            tab: '/assets/assets_charts_normal.svg',
            list: '/assets/charts_list.svg',
        },
    },
    survey: {
        id: 'survey',
        name: 'Surveys',
        asset: 'Survey',
        icons: {
            tab: '/assets/assets_surveys_normal.svg',
            list: '/assets/surveys_list.svg',
        },
    },
    currency: {
        id: 'currency',
        name: 'Stories',
        asset: 'Story',
        icons: {
            tab: '/assets/assets_currencies_normal.svg',
            list: '/assets/currency_list.svg',
        },
    },
    geobuffer: {
        id: 'geobuffer',
        name: 'Geobuffer',
        asset: 'dataset',
        hide: true,
    },
    mapspice: {
        id: 'mapspice',
        name: 'Maps',
        asset: 'Map',
        icons: {
            tab: '/assets/assets_maps_normal.svg',
            list: '/assets/mapspice_list.svg',
        },
    },
    layout: {
        id: 'layout',
        name: 'Templates',
        asset: 'Template',
        icons: {
            tab: '/assets/assets_layouts_normal.svg',
            list: '/assets/layout_list.svg',
        },
    },
};



// WEBPACK FOOTER //
// ./src/helpers/InitialAppsState.js